interface Props {
  onContact: () => void;
  onTerminal: () => void;
  ready: boolean;
}

export default function Hud({ onContact, onTerminal, ready }: Props) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        zIndex: 5,
        opacity: ready ? 1 : 0,
        transition: "opacity 0.6s ease 0.3s",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "1.25rem",
          left: "1.5rem",
          fontFamily: "var(--mono)",
          fontSize: "0.8125rem",
          color: "var(--fg-dim)",
          letterSpacing: "0.04em",
        }}
      >
        <span style={{ color: "var(--accent)" }}>brainsteam</span>
        <span style={{ color: "var(--fg-dim)" }}> // labs</span>
        <span
          style={{
            display: "inline-block",
            width: 6,
            height: 6,
            marginLeft: 10,
            borderRadius: "50%",
            background: "var(--status-live)",
            boxShadow: "0 0 6px var(--status-live)",
            verticalAlign: "middle",
            animation: "bs-heartbeat 2.6s ease-in-out infinite",
          }}
          aria-hidden="true"
        />
        <style>{`@keyframes bs-heartbeat {
          0%, 100% { opacity: 0.35; transform: scale(0.85); }
          50% { opacity: 1; transform: scale(1.15); }
        }`}</style>
      </div>
      <div
        style={{
          position: "absolute",
          top: "1.25rem",
          right: "1.5rem",
          fontFamily: "var(--mono)",
          fontSize: "0.75rem",
          color: "var(--fg-dim)",
          letterSpacing: "0.04em",
        }}
      >
        <Legend color="var(--status-live)" label="live" />
        <Legend color="var(--status-beta)" label="beta" />
        <Legend color="var(--status-building)" label="building" />
        <Legend color="var(--status-dormant)" label="dormant" />
      </div>
      <div
        style={{
          position: "absolute",
          bottom: "1.25rem",
          left: "1.5rem",
          fontFamily: "var(--mono)",
          fontSize: "0.75rem",
          color: "var(--fg-dim)",
        }}
      >
        click a node · drag to orbit · scroll to zoom
      </div>
      <div
        style={{
          position: "absolute",
          bottom: "1.25rem",
          right: "1.5rem",
          display: "flex",
          gap: "0.5rem",
          pointerEvents: "auto",
        }}
      >
        <button onClick={onTerminal}>{"["}terminal{"]"}</button>
        <button onClick={onContact}>{"["}contact{"]"}</button>
      </div>
    </div>
  );
}

function Legend({ color, label }: { color: string; label: string }) {
  return (
    <span style={{ marginLeft: "0.85rem" }}>
      <span
        style={{
          display: "inline-block",
          width: 8,
          height: 8,
          borderRadius: 8,
          background: color,
          marginRight: "0.35rem",
          verticalAlign: "middle",
          boxShadow: `0 0 6px ${color}`,
        }}
      />
      {label}
    </span>
  );
}
